<template>
    <div class="the-game" :class="tabsIndex === 0 ? 'activeVH' : ''">

        <Header :name="name" />
        <div class="content-box">
            <Tab :tabs="tabs" @OnTabs="handleOnTabs"></Tab>
            <div class="content" :class="tabsIndex == 1 ? 'active-padd' : ''">
                <div v-show="tabsIndex == 0">
                    <div class="flex-space-between mine-nav">
                        <div class="flex-space-between ranking">
                            <div class="label" :class="rankingIndex === index ? 'active' : ''"
                                v-for="(item, index) in ranking" :key="index" @click="handleRanking(index)">{{ item }}
                            </div>
                        </div>
                        <div class="nav-right ranking" v-if="rankingIndex != 3">
                            <div class="text "
                                :class="conduct == 1 ? 'conduct-js' : conduct == 2 ? 'conduct-jx' : 'conduct-wks'">
                                {{ gameStatus }}</div>
                        </div>
                    </div>
                    <div class="group-data" :class="rankingIndex == 3 ? 'cumulative' : ''">
                        <div class="flex-space-between  column column-bac">
                            <div class="item-data">{{ groupName || '-' }}</div>
                            <div class="item-data" v-for="(item, index) in matchRound" :key="index">{{ item }}</div>
                        </div>
                        <div class="content-arae">
                            <template v-if="groupDataList.length > 0">
                                <div class="flex-space-around column"
                                    :class="userInfoId.agentId == item.service_id ? 'active' : ''"
                                    v-for="(item, index) in groupDataList" :key="index">
                                    <div class="flex-flex-start item-data">
                                        <div class="num">{{ index + 1 }}</div>
                                        <div class="text-line2 name">{{ item.team_name || '-' }}</div>
                                    </div>
                                    <div class="item-data">
                                        <!-- <img v-if="item.team_score" src="../../assets/images/winterGame/jb.png"  />  -->
                                        {{ rankingIndex == 3 ? item.medal_count || '-' : item.team_score || '-' }}
                                    </div>
                                    <template v-if="rankingIndex == 3">
                                        <div class="item-data" v-for="(ran, i) in item.sections && item.sections "
                                            :key="i">{{ ran.medal_count || '-' }}</div>
                                    </template>
                                    <template v-else>
                                        <div class="item-data">{{ item.pk_count || '-' }}</div>
                                        <div class="item-data">{{
                                            Math.round(Number(item.win_rate || 0) / 100) ||
                                                '-'
                                        }}<span v-if="item.win_rate">%</span> </div>
                                        <div class="item-data">{{ item.medal_count || '-' }}</div>
                                    </template>
                                </div>
                            </template>
                            <div class="flex-vertically-center empty-data" v-else>暂无数据</div>
                        </div>
                    </div>
                    <!-- <div class="total">
                        <ul class="flex-space-around">
                            <li class="item-data">{{ currentAchievements.team_name || '-' }}</li>
                            <li class="item-data"><img v-if="currentAchievements.team_score" src="../../assets/images/winterGame/jb.png" alt="" /> {{ currentAchievements.team_score || '-' }}</li>
                            <li class="item-data">{{ currentAchievements.pk_count || '-' }}</li>
                            <li class="item-data">
                                <template v-if="rankingIndex == 3">
                                    {{Math.round(Number(currentAchievements.win_rate || 0)/ 100)  || '-'  || '-'}}
                                </template>
                                <template v-else>
                                    {{ Math.round(Number(currentAchievements.win_rate || 0)/ 100)  || '-' }}<span v-if="currentAchievements.win_rate">%</span>
                                </template>
                            </li>
                            <li class="item-data">{{ currentAchievements.medal_count || '-' }}</li>
                        </ul>
                    </div> -->
                </div>
                <div v-if="tabsIndex == 1">
                    <div class="flex-space-around-no war-zone-tab">
                        <div class="eliminate" :class="eliminateIndex === index ? 'active' : ''"
                            v-for="(tab, index) in warZoneTabs" :key="index" @click="handleWarZoneTabs(index)">
                            <span>{{ tab }}</span>
                        </div>
                    </div>
                    <!-- <aa></aa> -->
                    <component :is="isAssembly" :warZone="warZone" :playGgame="competitionHegemony"
                        :groupName="this.warZoneTabs[0]" :isShowTop16="isShowTop16" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import Header from '../../components/SquirrelCupII/battalionHeader'
import Tab from '../../components/SquirrelCupII/groupTab';
import StudentTable from '../../components/SquirrelCupII/student-data.vue'
import warZone from '../../components/SquirrelCupII/war-zone'
import championships from '../../components/SquirrelCupII/championships'
import { teamGroupSectionRank, teamGroupRank, teamKnockoutRank } from "../../api/winterGame";
export default {
    components: { Header, Tab, StudentTable, warZone, championships },
    data() {
        return {
            name: '战队排行',
            defaultTheater: { '青龙战区': [[[{ name: '青龙1组', rank: '第1名' }, { name: '青龙人气', rank: '第2名' }], [{ name: '青龙2组', rank: '第1名' }, { name: '青龙人气', rank: '第4名' }],], [[{ name: '青龙3组', rank: '第1名' }, { name: '青龙6组', rank: '第2名' }], [{ name: '青龙4组', rank: '第1名' }, { name: '青龙5组', rank: '第2名' }],], [[{ name: '青龙5组', rank: '第1名' }, { name: '青龙4组', rank: '第2名' }], [{ name: '青龙6组', rank: '第1名' }, { name: '青龙3组', rank: '第2名' }],], [[{ name: '青龙人气', rank: '第1名' }, { name: '青龙2组', rank: '第2名' }], [{ name: '青龙人气', rank: '第3名' }, { name: '青龙1组', rank: '第2名' }],],], '白虎战区': [[[{ name: '白虎1组', rank: '第1名' }, { name: '白虎人气', rank: '第2名' }], [{ name: '白虎2组', rank: '第1名' }, { name: '白虎人气', rank: '第4名' }],], [[{ name: '白虎3组', rank: '第1名' }, { name: '白虎6组', rank: '第2名' }], [{ name: '白虎4组', rank: '第1名' }, { name: '白虎5组', rank: '第2名' }],], [[{ name: '白虎5组', rank: '第1名' }, { name: '白虎4组', rank: '第2名' }], [{ name: '白虎6组', rank: '第1名' }, { name: '白虎3组', rank: '第2名' }],], [[{ name: '白虎人气', rank: '第1名' }, { name: '白虎2组', rank: '第2名' }], [{ name: '白虎人气', rank: '第3名' }, { name: '白虎1组', rank: '第2名' }],],], '朱雀战区': [[[{ name: '朱雀1组', rank: '第1名' }, { name: '朱雀人气', rank: '第2名' }], [{ name: '朱雀2组', rank: '第1名' }, { name: '朱雀人气', rank: '第4名' }],], [[{ name: '朱雀3组', rank: '第1名' }, { name: '朱雀6组', rank: '第2名' }], [{ name: '朱雀4组', rank: '第1名' }, { name: '朱雀5组', rank: '第2名' }],], [[{ name: '朱雀5组', rank: '第1名' }, { name: '朱雀4组', rank: '第2名' }], [{ name: '朱雀6组', rank: '第1名' }, { name: '朱雀3组', rank: '第2名' }],], [[{ name: '朱雀人气', rank: '第1名' }, { name: '朱雀2组', rank: '第2名' }], [{ name: '朱雀人气', rank: '第3名' }, { name: '朱雀1组', rank: '第2名' }],],], '玄武战区': [[[{ name: '玄武1组', rank: '第1名' }, { name: '玄武人气', rank: '第2名' }], [{ name: '玄武2组', rank: '第1名' }, { name: '玄武人气', rank: '第4名' }],], [[{ name: '玄武3组', rank: '第1名' }, { name: '玄武6组', rank: '第2名' }], [{ name: '玄武4组', rank: '第1名' }, { name: '玄武5组', rank: '第2名' }],], [[{ name: '玄武5组', rank: '第1名' }, { name: '玄武4组', rank: '第2名' }], [{ name: '玄武6组', rank: '第1名' }, { name: '玄武3组', rank: '第2名' }],], [[{ name: '玄武人气', rank: '第1名' }, { name: '玄武2组', rank: '第2名' }], [{ name: '玄武人气', rank: '第3名' }, { name: '玄武1组', rank: '第2名' }]]] },
            tabs: ["小组赛", "淘汰赛"],
            warZoneTabs: ["朱雀战区", "四强争冠赛"],
            ranking: ["第一轮", "第二轮", "第三轮", "累计排名"],
            matchRound: ['奖杯数', '局数', '胜率', '勋章'],
            cumulativeRanking: ["总勋章", "第一轮", "第二轮", "第三轮"],
            currentRounds: '第一轮',
            isShowTop16: '',
            gameStatus: '',
            conduct: 1,// 进行中
            tabsIndex: 0, // 切换索引
            eliminateIndex: 0, // 淘汰赛切换索引
            rankingIndex: 0, // 第几轮
            isAssembly: 'warZone',
            currentAchievements: {},
            groupName: '',
            agentRank: {},
            groupInitData: [],
            tabArr: [],
            groupDataList: [], //小组比赛数据
            // 战区排名
            warZone: {
                top16: [],
                topUpper8: [],
                topLower8: [],
                topUpper4: [],
                topLower4: [],
                topUpper2: []
            },
            // 争霸赛
            competitionHegemony: {
                fourUpper: [],
                fourLower: [],
                tow: [],
                three: [],

            }

        };
    },
    created() {
        // localStorage.setItem('userInfoId', JSON.stringify({openId:'oFJ6Z4qVu6hLy0xicIMfvzEfV29Q', agentId: 128}))
        this.initData()
    },
    mounted() {
        let date1 = new Date('2023/01/29');
        let date2 = new Date();
        this.isShowTop16 = date2 >= date1 ? true : false
    },
    watch: {
        'warZone.top16': {
            handler: function (newVal, oldVal) {
                if (newVal.length === 0) {

                }
            },
            deep: true
        }
    },
    methods: {
        async initData() {
            this.userInfoId = await JSON.parse(localStorage.getItem('userInfoId')) || {};
            await this.getCumulativeRanking('init')
            await this.getDateTime(this.groupInitData)
            await this.getDataList()

        },
        async getDateTime(newVal) {
            let date = new Date()
            let Y = date.getFullYear();  // 获取完整的年份(4位,1970)
            let M = date.getMonth() + 1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
            let D = date.getDate();  // 获取日(1-31)
            let currentTime = Y + '/' + M + '/' + D;
            let arr = []
            console.log(newVal)
            await newVal && newVal.length > 0 && newVal[0].sections.map((item, index) => {
                let date1 = new Date((item.start_date).replace(/-/g, "/"));
                let date2 = new Date((item.end_date).replace(/-/g, "/"));
                let date3 = new Date();
                if (date3 >= date1 && date3 <= date2) {
                    console.log('进行中')
                    arr.push({ name: '进行中', conduct: 1, isType: true })
                    this.conduct = 1
                    this.gameStatus = '进行中'
                }
                if (date3 <= date1) {
                    console.log('暂未开始')
                    arr.push({ name: '未开始', conduct: 3, isType: false })
                    this.conduct = 3
                }
                if (date3 >= date2 && date3 >= date1) {
                    console.log('已结束')
                    arr.push({ name: '已结束', conduct: 2, isType: true })
                    this.conduct = 2
                    this.gameStatus = '已结束'
                }
                console.log(item)
            })
            this.tabArr = arr
            await arr.map((item, index) => {
                if (item.conduct == 1) {
                    console.log('---yy', item)
                    this.gameStatus = item.name || ''
                    this.conduct = item.conduct
                    this.rankingIndex = index
                    this.currentRounds = item.name
                }
            })
            console.log('arr', arr)

        },
        // 获取小组赛
        async getDataList(match) {
            let { userInfoId, ranking, rankingIndex } = this
            console.log(userInfoId)
            let params = {
                param: {
                    openId: userInfoId.openId,
                    agentId: userInfoId.agentId,
                    sectionName: match ? match : ranking[rankingIndex]
                }
            }
            await teamGroupSectionRank(params).then(res => {
                if (res.code === 0) {
                    let { groupName, agentRank, team_group_section_rank } = res.data || {}
                    this.currentAchievements = agentRank && agentRank || {}
                    this.groupName = groupName && groupName || ''
                    this.groupDataList = team_group_section_rank && team_group_section_rank || []
                }
            })
        },
        // 累计排名
        async getCumulativeRanking(type) {
            let { openId, agentId } = this.userInfoId || {}
            let params = {
                param: { openId, agentId }
            }
            await teamGroupRank(params).then(res => {
                console.log(res)
                if (res.code === 0) {
                    let { agentRank, groupName, team_group_rank } = res.data || {}
                    this.groupInitData = team_group_rank || []
                    if (type === 'init') return
                    this.currentAchievements = agentRank || {}
                    this.groupName = groupName && groupName || ''
                    this.groupDataList = team_group_rank || []
                }
            })
        },
        // 淘汰赛
        getKnockout() {
            const that = this
            const { agentId, openId } = this.userInfoId
            let params = {
                param: { agentId, openId }
            }
            teamKnockoutRank(params).then(res => {
                if (res.code === 0) {
                    var teamInfo = {
                        "war_zone": "青龙战区",
                        "team_name": "我是飞虎队大队长",
                        "team_tag_id": "战队ID",
                        "service_id": 2000,//服务中心ID
                        "score": 100000,//奖杯数
                        "promotion": true//true晋级,false失败
                    }

                    var arr = {"code":0,"message":"","data":{"war_zone":"青龙战区","four_last_match":{"four":null,"two":null,"three":null},"war_zone_knockout":{"top_8":[[{"score":16926,"war_zone":"青龙战区","service_id":5080,"rule":"","team_name":"晋善晋美","promotion":true},{"score":11542,"war_zone":"青龙战区","service_id":4100,"rule":"","team_name":"永不言弃天狼团","promotion":false}],[{"score":16474,"war_zone":"青龙战区","service_id":6917,"rule":"","team_name":"粤K战队","promotion":false},{"score":23572,"war_zone":"青龙战区","service_id":5414,"rule":"","team_name":"学苗蜕变训练营","promotion":true}],[{"score":19716,"war_zone":"青龙战区","service_id":5479,"rule":"","team_name":"无敌学霸天团","promotion":true},{"score":13386,"war_zone":"青龙战区","service_id":4888,"rule":"","team_name":"武安顶峰战队","promotion":false}],[{"score":10891,"war_zone":"青龙战区","service_id":5065,"rule":"","team_name":"乐平学霸争第一","promotion":true},{"score":2947,"war_zone":"青龙战区","service_id":5522,"rule":"","team_name":"乐学天团","promotion":false}]],"top_4":[[{"score":27744,"war_zone":"青龙战区","service_id":5080,"rule":"","team_name":"晋善晋美","promotion":true},{"score":24348,"war_zone":"青龙战区","service_id":5414,"rule":"","team_name":"学苗蜕变训练营","promotion":false}],[{"score":22382,"war_zone":"青龙战区","service_id":5479,"rule":"","team_name":"无敌学霸天团","promotion":true},{"score":12357,"war_zone":"青龙战区","service_id":5065,"rule":"","team_name":"乐平学霸争第一","promotion":false}]],"top_16":[[[{"score":11462,"war_zone":"青龙战区","service_id":5449,"rule":"1-1","team_name":"吉莱姆梦想战队","promotion":false},{"score":14542,"war_zone":"青龙战区","service_id":5080,"rule":"fh-2","team_name":"晋善晋美","promotion":true}],[{"score":9499,"war_zone":"青龙战区","service_id":4100,"rule":"2-1","team_name":"永不言弃天狼团","promotion":true},{"score":7465,"war_zone":"青龙战区","service_id":5290,"rule":"fh-4","team_name":"打好基础冲巅峰","promotion":false}]],[[{"score":15545,"war_zone":"青龙战区","service_id":6917,"rule":"3-1","team_name":"粤K战队","promotion":true},{"score":15215,"war_zone":"青龙战区","service_id":4653,"rule":"6-2","team_name":"独一无二","promotion":false}],[{"score":21766,"war_zone":"青龙战区","service_id":5414,"rule":"4-1","team_name":"学苗蜕变训练营","promotion":true},{"score":21001,"war_zone":"青龙战区","service_id":5029,"rule":"5-2","team_name":"野狼队","promotion":false}]],[[{"score":20474,"war_zone":"青龙战区","service_id":5479,"rule":"5-1","team_name":"无敌学霸天团","promotion":true},{"score":5090,"war_zone":"青龙战区","service_id":5438,"rule":"4-2","team_name":"海城领航松鼠AI","promotion":false}],[{"score":10617,"war_zone":"青龙战区","service_id":4888,"rule":"6-1","team_name":"武安顶峰战队","promotion":true},{"score":2145,"war_zone":"青龙战区","service_id":5282,"rule":"3-2","team_name":"武汉是那个事","promotion":false}]],[[{"score":13174,"war_zone":"青龙战区","service_id":5065,"rule":"fh-1","team_name":"乐平学霸争第一","promotion":true},{"score":9680,"war_zone":"青龙战区","service_id":4643,"rule":"2-2","team_name":"超我战队","promotion":false}],[{"score":4862,"war_zone":"青龙战区","service_id":5522,"rule":"fh-3","team_name":"乐学天团","promotion":true},{"score":4815,"war_zone":"青龙战区","service_id":5896,"rule":"1-2","team_name":"蓝眼泪","promotion":false}]]],"top_2":[{"score":1431,"war_zone":"青龙战区","service_id":5080,"rule":"","team_name":"晋善晋美","promotion":true},{"score":1353,"war_zone":"青龙战区","service_id":5479,"rule":"","team_name":"无敌学霸天团","promotion":true}]}}}
                    const { war_zone_knockout, four_last_match, war_zone } = res.data || {}
                    /** 战区 */
                    // let war_zone = '朱雀战区'
                //   try {
                    let defaultTheaterDataList = []
                    if (!war_zone_knockout || (war_zone_knockout && !war_zone_knockout.top_16)) {
                        let { defaultTheater } = this
                        Object.entries(defaultTheater).map(([key, val]) => {
                            let warZone = key.includes(war_zone || '')
                            if (warZone) {
                                defaultTheaterDataList = val || []
                            }
                        })
                    }
                    const fourWarZones = ['青龙战区冠军', '白虎战区冠军', '朱雀战区冠军', '玄武战区冠军']
                    this.$set(this.warZoneTabs, 0, war_zone || '')
                    // 16 强
                    // this.$set(this.warZone, 'top16', [{name: 456}])
                    this.warZone['top16'] = war_zone_knockout && war_zone_knockout.top_16 && war_zone_knockout.top_16.length > 0 ? war_zone_knockout.top_16 || [] : defaultTheaterDataList
                    // 8 强
                    this.warZone['topUpper8'] = war_zone_knockout && war_zone_knockout.top_8 && war_zone_knockout.top_8.length > 0 ? war_zone_knockout.top_8.slice(0, 2) || [] : []
                    this.warZone['topLower8'] = war_zone_knockout && war_zone_knockout.top_8 && war_zone_knockout.top_8.length > 0 ? war_zone_knockout.top_8.slice(2, 4) || [] : []
                    // 4 强
                    this.warZone['topUpper4'] = war_zone_knockout && war_zone_knockout.top_4 && war_zone_knockout.top_4.length > 0  ? war_zone_knockout.top_4[0]  : []
                    this.warZone['topLower4'] = war_zone_knockout && war_zone_knockout.top_4 && war_zone_knockout.top_4.length > 0  ? war_zone_knockout.top_4[1]  : []
                    // 2 强
                    this.warZone['topUpper2'] = war_zone_knockout && war_zone_knockout.top_2 || []
                    /** 争霸赛 */
                    // 4强赛
                    this.competitionHegemony['fourUpper'] = ((four_last_match && four_last_match.four) ? four_last_match.four[0] || [] : fourWarZones.slice(0, 2))
                    this.competitionHegemony['fourLower'] = ((four_last_match && four_last_match.four) ? four_last_match.four[1] || [] : fourWarZones.slice(2, 4))
                    // 冠军赛
                    this.competitionHegemony['tow'] = four_last_match ? four_last_match.two || [] : []
                    // 季军赛
                    this.competitionHegemony['three'] = four_last_match ? four_last_match.three || [] : []
                    //   } catch (error) { console.log(error) }
                }
            })
        },
        // 小组赛-淘汰赛切换
        handleOnTabs(index) {
            this.tabsIndex = index
            if (index === 1) {
                this.getKnockout()
            }
        },
        // 淘汰赛切换
        handleWarZoneTabs(index) {
            this.eliminateIndex = index
            this.getKnockout()
            if (index === 0) {
                this.isAssembly = 'warZone'
            } else {
                this.isAssembly = 'championships'
            }
        },
        async handleRanking(index) {
            let tabArr = this.tabArr
            let isTag = false
            let gameStatus = '', conduct = ''
            tabArr.map((item, i) => {
                if (index === i) {
                    console.log('--ii', item)
                    if (index === i && !item.isType) {
                        Toast(item.name);
                        console.log(item)
                        isTag = true
                    }
                    if (index === i && item.isType) {
                        gameStatus = item.name || ''
                        conduct = item.conduct
                    }
                }

            })
            if (isTag) return
            this.gameStatus = gameStatus
            this.conduct = conduct
            this.rankingIndex = index;
            let cumulative = ["总勋章", "第一轮", "第二轮", "第三轮"]
            let matchRound = ['奖杯数', '局数', '胜率', '勋章']
            let ranking = await this.ranking[index]
            this.currentRounds = ranking
            if (index !== 3) {
                this.matchRound = matchRound
                await this.getDataList(ranking)
            } else {
                this.matchRound = cumulative
                await this.getCumulativeRanking()
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import "../../assets/style/global.less";

.empty-data {
    color: #c8c9cc;
    font-size: 20px;
    min-height: 400px;
}

.the-game {
    width: 100%;
    // padding-bottom: 100px;
    background-image: linear-gradient(180deg, #002455 0%, #001D46 100%), linear-gradient(180deg, #00236D 0%, #001D46 100%);

    &.activeVH {
        height: 100vh;
    }

    .content-box {
        margin: 0 22px;

        .content {
            padding: 50px 0;
            background: white;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            position: relative;

            &.active-padd {
                padding-left: 18px;
                padding-right: 18px;
            }

            .mine-nav {
                padding: 0 22px 20px 22px;

                .ranking {
                    .label {
                        color: #A8A8A8;
                        font-size: 24px;
                        margin-right: 10px;
                        padding: 10px 15px;
                        box-sizing: border-box;
                        border: 2px solid #ECECEC;
                        border-radius: 10px;

                        &.active {
                            color: #1C96FF;
                            border: 2px solid #1C96FF;
                        }
                    }

                    .text {
                        font-size: 24px;
                        font-weight: 700;

                        &.conduct-jx {
                            color: #62B7FF;
                        }

                        &.conduct-js {
                            color: #FF972A;
                        }

                        &.conduct-wks {
                            color: #A8A8A8;
                        }
                    }
                }
            }

            .group-data {
                // padding: 4px 4px;

                .column-bac {
                    background: #CBE7FF;
                    padding: 0 40px;
                    margin: 0 10px;

                    .item-data {
                        color: #333333 !important;
                        font-size: 24px;
                        font-weight: 500;
                    }
                }

                .content-arae {
                    max-height: 600px;
                    min-height: 300px;
                    overflow-y: auto;
                }

                .column {
                    padding: 0;
                    margin: 0;
                    border-bottom: 1px solid #EEEEEE;
                    padding: 22px 0;

                    &.active {
                        background: #23AFFF;

                        .item-data {
                            color: white;

                            .num {
                                color: white;
                            }
                        }
                    }

                    .item-data {
                        font-size: 24px;
                        font-weight: 400;
                        color: #333333;
                        padding: 0 14px;
                        width: 17%;
                        word-break: break-all;

                        .num {
                            font-size: 28px;
                            font-weight: 600;
                            color: #333333;
                            padding-right: 5px;
                            flex-shrink: 0;
                        }

                        .name {}

                        &:first-child {
                            width: 40%;
                        }

                        // &:nth-child(2){
                        //   width: 22%;
                        // }
                        // &:nth-child(2){
                        //    width: 18%;
                        // }
                        &:last-child,
                        &:nth-child(3),
                        &:nth-child(4) {
                            width: 13%;
                        }
                    }
                }

                // 累计排名
                &.cumulative {
                    .column {
                        .item-data {
                            width: 16%;

                            &:first-child {
                                width: 35%;
                            }

                            //     &:last-child,&:nth-child(3),&:nth-child(4){
                            //     width: 13%;
                            // }
                        }
                    }
                }
            }

            .total {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                // height: 64px;
                background: linear-gradient(135deg, #1B94FF 0%, #23B0FF 100%);
                box-shadow: 0px -4px 12px 0px rgba(0, 0, 0, 0.4);
                border-radius: 0px 0px 8px 8px;
                color: #fff;
                padding: 18px 22px;

                ul {
                    width: 100%;
                    margin: 0 auto;
                    padding: 0;

                    li,
                    .item-data {
                        font-size: 24px;
                        font-weight: 400;
                        color: #FFFFFF;
                        width: 19%;
                        padding: 0 14px;

                        &:first-child {
                            width: 24%;
                        }

                        &:nth-child(2) {
                            width: 22%;
                        }

                        &:nth-child(3),
                        &:nth-child(4),
                        &:nth-child(5) {
                            width: 18%;
                        }

                        &.hide {
                            opacity: 0;
                        }
                    }
                }
            }

            /** 淘汰赛 */
            .war-zone-tab {
                width: 70%;
                margin: 0 auto;

                .eliminate {
                    font-size: 28px;
                    font-weight: 400;
                    color: #999999;
                    position: relative;

                    &.active {
                        color: #1C96FF;
                        font-weight: 600;

                        &::after {
                            content: '';
                            width: 40px;
                            height: 8px;
                            background: linear-gradient(135deg, #1B94FF 0%, #23B0FF 100%);
                            border-radius: 5px;
                            position: absolute;
                            left: 50%;
                            bottom: -20px;
                            transform: translate(-50%, 0);
                        }
                    }
                }
            }
        }
    }
}

/**  设置公共样式 */
</style>
